export default __webpack_public_path__ + "static/media/qr_code_1.a1f627ca.jpg";